import Content from "@arelia-components/layout/Content";
import Header from "@arelia-components/layout/Header";
import { ContentBox } from "@arelia-components/ui-atoms/ContentBox";

export default function PerformanceRevenue() {

  return (
    <ContentBox>
      <Header
        title="Performance Revenue"
        backTo={{
          label: "back to earnings",
          path: "/earnings"
        }}
      />
      <Content />
    </ContentBox>
  );
}
